import { Outlet } from "react-router-dom"
import Header from "../../components/Header"
import Footer from "../../components/Footer"
import ScrollToTop from "../../components/ScrollToTop"

const BasicLayout = () => {
    return (
        <>
            <Header />
            <div className="container__outlet">
                <Outlet />
            </div>
            <Footer />
            <ScrollToTop />
        </>
    )
}

export default BasicLayout